let Api = {
     "TYPE_LIST": "/simple-api/n/qpstzx/flzx/type/list", //法律类型接口
     "LSGL_LIST": "/simple-api/n/qpstzx/flzx/lsgl/list", //律所列表
     "XSYZT_LIST": "/simple-api/n/qpstzx/xsyzt/xsyzt/list", //线上云展厅
     "B2B_W_AREA_FINDAREATREE": "/system/n/area/findAreaTree", //省市县
    
      "FLZX_FLZXADD": "/simple-api/n/qpstzx/flzx/flzxAdd", //法律咨询添加
      "FLZX_GZZXADD": "/simple-api/n/qpstzx/flzx/gzzxAdd", //公证咨询添加
     //   "FLZX_GZZXADD": "/simple-api/n/qpstzx/flzx/lsgl/list", //公证咨询添加
      "TIANDITUAPI_GETDRIVEROUTE": "/portal-api/n/tiandituapi/getDriveRoute", //地图轨迹
      
       "XXPX_TRAINDETAIL": "/simple-api/n/qpstzx/xxpx/trainDetail", //线下培训详细信息

       "PXFW_COURSESDETAIL": "/simple-api/n/qpstzx/pxfw/coursesDetail", //线下课程详细信息
       "PXFW_COURSESSAMELIST": "/simple-api/n/qpstzx/pxfw/coursesSameList", //线下相关课程

       "QPSTZX_INDEX_TYPZBYBH": "/simple-api/n/qpstzx/index/typzByBh", //市场分析报告

       "QPSTZX_INDEX_WLCPLIST": "/simple-api/n/qpstzx/bjfw/wlCpList", //外贸物流





       


       


       
} 
module.exports = Api